module.exports = __webpack_public_path__ + "img/cavalier-challenge-2-tablet_78add4f3007b1d85c232d63ea04976fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/img/cavalier-challenge-2-tablet.jpg
// module id = 267
// module chunks = 0